const qParams = {
  email: 'e',
  userId: 'ui',
  sessionToken: 'st',
  deviceToken: 'dt',
} as const;

export default qParams;
